import styles from './styles'

const getCrossStyle = overrideStyles => {
  let crossStyle = { ...styles.cross }

  if (overrideStyles && overrideStyles.tags) {
    const { cross = {} } = overrideStyles.tags
    crossStyle = { ...crossStyle, ...cross }
  }

  return crossStyle
}

export default getCrossStyle
